import React from 'react';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';

import Icon from '../Icon/Icon';
import TooltipComponent from 'components/Tooltip/Tooltip';

interface Options {
  className?: string;
  hintId?: string;
}

export const withArrow = (id: string, options?: Options) => {
  const { className, hintId } = options ?? {};

  return (
    <div className="table-header">
      <div className={classNames('header-name', className)}>
        <FormattedMessage id={id} />

        {!!hintId && (
          <TooltipComponent content={<FormattedMessage id={hintId} />}>
            <Icon className="header-hint-icon" type="helpCircle" />
          </TooltipComponent>
        )}
      </div>

      <Icon type="arrow" className="header-arrow" />
    </div>
  );
};
